import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CardContent, CardHeader, Typography, Tabs, Tab } from "@mui/material";
import BasicInfo from "./BasicInfo";
import ProductThumbnails from "./ProductThumbnails";
import ProductDetailsImages from "./ProductDetailsImages";
import GeneralInfo from "./GeneralInfo";

const ProductDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [images, setImages] = useState([]);
  const [detailsImages, setDetailsImages] = useState([]);
  const [generalInfo, setGeneralInfo] = useState([]);
  const [tabIndex, setTabIndex] = useState(0); // Ensure it's always initialized properly

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await fetch(
          `https://cms-test.my-ogawa.com/backend/script/bodyfriend/product/get_product_details.php?id=${id}`
        );
        const data = await response.json();
        setProduct(data.product);
        setImages(data.images);
        setDetailsImages(data.detailsMedia);
        setGeneralInfo(data.generalInfo || []);
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    fetchProductDetails();
  }, [id]);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  return (
    <div>
      <CardHeader
        title={<Typography variant="h4">Product Details</Typography>}
      />

      {/* Tabs Navigation */}
      <Tabs value={tabIndex} onChange={handleTabChange}>
        <Tab label="Basic Information" value={0} />
        <Tab label="Thumbnails" value={1} />
        <Tab label="Details Media" value={2} />
        <Tab label="General Information" value={3} />
      </Tabs>

      <CardContent sx={{ p: 0 }}>
        {product ? (
          <>
            {tabIndex === 0 && <BasicInfo product={product} />}
            {tabIndex === 1 && (
              <ProductThumbnails images={images} productName={product.name} />
            )}
            {tabIndex === 2 && (
              <ProductDetailsImages
                detailsImages={detailsImages}
                productName={product.name}
              />
            )}
            {tabIndex === 3 && <GeneralInfo generalInfo={generalInfo} />}
          </>
        ) : (
          <Typography color="textSecondary">Loading...</Typography>
        )}
      </CardContent>
    </div>
  );
};

export default ProductDetails;
